import type { FaireProductEntity } from "../../entity_types/product";

export const p_3fauqqs06m: FaireProductEntity = {
  token: "p_3fauqqs06m",
  type: "product",
  name: "Dog Days Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2d22a9247c1333a17eea4073f7dbfbd8eab7c4c0af1921ecf13babb6a8c2253d.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/628cea480697686c340b40f82150cb456ec85f6bcdd3301bb987821ffc89bc37.jpeg",
    "https://cdn.faire.com/fastly/35ff5b267f7c8c6d48e9ae15372a3d4a4ce9d05c937af949a2704a1272877b3b.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:50.692Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
